module.exports = __webpack_public_path__ + "img/lessonattend-confetti.2ad062c9.svg";